import { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import TwinForm from '../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../forms/TwinForm/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { LabelsPayload } from '../../../../../../utils/reducers/company/labels'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import CustomSelect, { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { InputHidden } from '../../../../../../forms/Input'
import { twinFetchPostPrinter } from '../../../../../../utils/globals/data'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import useOrderTypeSelectProductsDict from '../../../../../../utils/hooks/orders/useOrderTypeSelectProductsDict'
import { getConfigParam } from '../../../../../../utils/reducers/getters'

type ModalPrintTagsBuyProps = ModalEditComponentProps & ReduxModalPrintTagsBuy & {
    urlGetTag: string
    Order: TwinDictionary

}

const ModalPrintTagsBuy: React.FC<ModalPrintTagsBuyProps> = ({setOpened, urlGetTag, labels, specificPriceRules, ...logic}) => {
    const { loading, onPreSubmit, onSubmit } = useModalPrintTagsBuyLogic({ setOpened })
    const {t} = useTwinTranslation()
    const dictPrintProductType = useOrderTypeSelectProductsDict()
    const printType = {
        'allUnits': {name: t('allUnits', 'Todas las unidades')},
        'justOne': {name: t('justOne', 'Solo una unidad')}
    }
    const printTypeDefault = getConfigParam('workSheetTypeByDefault')
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false} className='flex_height'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={urlGetTag} onSubmit={onSubmit} className='flex flex-auto flex-col justify-between gap-10 ' triggerErrors={false} triggerSuccess={false}>
                <CustomSelectWithSearchBar items={labels || {}} label={t('tag', 'Etiqueta')} value={Object.keys(labels || {})?.[0] || ''} name='LabelId' required={true}/>
                <CustomSelectWithSearchBar items={specificPriceRules?.dictionary || {}} label={t('specificPriceRule', 'Tarifa')} value={specificPriceRules?.arrSorted?.[0]?.id || ''} name='SpecificPriceRuleId' required={true}/>
                <CustomSelect items={dictPrintProductType} label={t('typeProducts', 'Tipo de productos')} value={printTypeDefault || 'allProducts'} name='typeProducts' required={true}/>
                <CustomSelect items={printType} label={t('typePrinting', 'Tipo de impresión')} value={'allUnits'} name='typePrinting' required={true}/>
                <InputHidden name='OrderId' value={logic.Order?.id}/>
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => {}} onCancel={() => setOpened(null)} loading={loading}/>
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalPrintTagsBuyLogicProps {
    setOpened: ModalOpenedSetTy
}

const useModalPrintTagsBuyLogic = ({ setOpened }: ModalPrintTagsBuyLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const {t} = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading()
        return true
    }, [startLoading])

    const onSubmit: OnSubmit = useCallback(async (result) => {
         if(result && result.status === 367){
            const body = await result.json()
             const myresult = await twinFetchPostPrinter('/printLabel', body, errorMessage)
             if (myresult) {
                 setOpened(null)
             }
        }
        endLoading()
    }, [endLoading, setOpened, errorMessage])
    return { onPreSubmit, onSubmit, loading, endLoading }
}

const modalPrintTagsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setLabels: (payload: LabelsPayload) => ({ type: 'CHANGE_LABELS', payload }),
}

type ReduxModalPrintTagsBuy = ConnectedProps<typeof modalprinttagsbuyConnect>
const mapModalPrintTagsBuyConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, labels: state.labels })
const modalprinttagsbuyConnect = connect(mapModalPrintTagsBuyConnector, modalPrintTagsDispatch)

const modalprinttagsbuyConnectLoading = withLoading(ModalPrintTagsBuy, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/config/label/getAllLabels', propName: 'labels', setFunctionName: 'setLabels' }])
const ModalPrintTagsBuyConnect = modalprinttagsbuyConnect(modalprinttagsbuyConnectLoading)

export default ModalPrintTagsBuyConnect